import PropTypes from 'prop-types';

export function ElectionWeekCalendarHeader({ week }) {
  return (
    <div className="sticky top-0 z-20 border-b border-stone-200 bg-stone-50/95 backdrop-blur">
      <div className="px-4 pt-4 sm:px-5">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-stone-500">
          {week.weekLabel}
        </p>
      </div>

      <div className="grid grid-cols-[4.75rem_repeat(7,minmax(8rem,1fr))] gap-0 border-t border-stone-200">
        <div className="border-r border-stone-200 px-2 py-3 text-xs font-medium text-stone-500">
          Time
        </div>

        {week.days.map((day) => (
          <div key={day.date} className="border-r border-stone-200 px-2 py-3 last:border-r-0">
            <div className="flex min-h-[3.5rem] flex-col justify-center">
              <span className="text-sm font-semibold text-stone-900">{day.weekdayShort}</span>
              <span className="text-sm text-stone-600">{day.monthDay}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

ElectionWeekCalendarHeader.propTypes = {
  week: PropTypes.shape({
    weekLabel: PropTypes.string.isRequired,
    days: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string.isRequired,
        weekdayShort: PropTypes.string.isRequired,
        monthDay: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};
